import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { MinimalAPIError } from 'components/core/errors/api'
import { C1MultiUserDisplay } from 'components/core/multi-user/C1MultiUserDisplay'
import { SearchManagedUsersRequest } from 'pbts/c1/api/user/v1/user'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { managedUserSearchApi } from 'redux_toolkit/users'

interface DirectReportsForUserProps {
  managerId: string
}

export const DirectReportsForUser: FC<DirectReportsForUserProps> = ({ managerId }) => {
    const intl = useIntl()

  // Provide all required fields for SearchManagedUsersRequest
    const { data, isError, error } = managedUserSearchApi.useSearchManagedUsers(SearchManagedUsersRequest.create({
        managerId,
        pageSize: 20,
    }))

    if (isError) return <MinimalAPIError err={typeof error === 'string' ? error : (error?.message || intl.formatMessage({ id: 'components_user_details_no_direct_reports', defaultMessage: 'No direct reports found' }))} />

    const users = data?.flat() || []

    if (users.length === 0) {
        return <C1EmptyIndicator />
    }
    return <C1MultiUserDisplay users={users} readOnly showTooltip={false} />
}
